import { imageUrlFor } from '@/sanity'

/**
 * Generate route object from data entry
 * @param {Object} item
 */
export function route(item) {
  if (!(item && item.slug && item._type)) return
  return { name: item._type, params: { slug: item.slug } }
}

/**
 * Generate image URL forsocial media previews
 * @param {Object} image Image object
 * @param {Number} width Width in px
 */
export function socialUrl(image, width = 1500) {
  if (!image) return ''

  return imageUrlFor(image)
    .ignoreImageParams()
    .width(width)
    .fit('max')
    .auto('format')
    .quality(80)
}
